import { observer } from 'mobx-react-lite'
import TextField, { TextFieldProps } from '@mui/material/TextField'
import useStore from 'reusable/mobx-store-utils'
import ObservableRef from 'reusable/mobx-store-utils/ObservableRef'
import { deferAction } from 'reusable/utils/utils'

export default observer(function TextFieldCustom({ autoFocus, ...props }: TextFieldProps) {
   const localStore = useStore(
      sp => ({
         ref: new ObservableRef<HTMLInputElement>({
            onSet: () => {
               if (sp.inputRef) {
                  if (typeof sp.inputRef === 'function') {
                     sp.inputRef(localStore.ref.current)
                  }
               }
               if (sp.autoFocus) {
                  const input = localStore.ref.current
                  if (!input) {
                     return
                  }

                  deferAction(() => {
                     input.focus()
                     input.select()
                  })
               }
            },
         }),
      }),
      { ...props, autoFocus }
   )

   return <TextField {...props} inputRef={localStore.ref.set} />
})
